import React from "react";
import styles from "./Detail.module.scss";
import CopyTextToClipBoardButton from "gui/components/copyTextToClipBoardButton/CopyTextToClipBoardButton";
import {ReactComponent as CopyIcon} from 'assets/img/copyIcon.svg';

export interface IDetailProps {
  title?: string;
  value?: string;
  href?: string;
  copyValue?: string;
}

const Detail = ({title, value, href, copyValue}: IDetailProps) => {
  return (
    <div className={[styles.Detail, 'detail'].join(' ')}>
      <span>{title}</span>:
      &nbsp;
      {href ? <a href={href}>{value}</a> : <span>{value}</span>}
      {copyValue ? <CopyTextToClipBoardButton text={copyValue} copyIcon={CopyIcon}/> : null}
    </div>
  )
}

Detail.defaultProps = {
  title: "",
  value: "",
};

export default Detail;
